import React from 'react';
import Section from '../layout/Section';
import BentoCard from '../ui/BentoCard';
import { bentoItems } from '../../data/bentoItems';
import StaggerContainer from '../animations/StaggerContainer';
import TextReveal from '../animations/TextReveal';
import ScrollParallax from '../animations/ScrollParallax';

export default function BentoGridSection() {
  return (
    <Section dark id="features">
      {/* Custom title block with accent */}
      <ScrollParallax speed={-10}>
        <div className="text-center mb-6 sm:mb-10 lg:mb-14">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary/10 border border-primary/20 text-primary text-xs font-semibold tracking-widest uppercase mb-3 sm:mb-5">
            Fonctionnalités
          </span>
          <TextReveal
            as="h2"
            className="text-3xl sm:text-4xl lg:text-5xl font-extrabold leading-tight gradient-text"
          >
            Tout ce dont votre boutique a besoin
          </TextReveal>
          <p className="mt-4 text-base sm:text-lg max-w-2xl mx-auto text-gray-400 leading-relaxed">
            Chaque fonctionnalité a été conçue pour les commerçants africains.
            <br className="hidden sm:block" />
            Pas de superflu, que de l'utile.
          </p>
        </div>
      </ScrollParallax>

      <StaggerContainer className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 sm:gap-3 lg:gap-5">
        {bentoItems.map((item, index) => (
          <ScrollParallax
            key={item.title}
            speed={index % 2 === 0 ? -8 : -15}
            className={item.colSpan === 2 ? 'md:col-span-2' : 'col-span-1'}
          >
            <BentoCard {...item} index={index} />
          </ScrollParallax>
        ))}
      </StaggerContainer>
    </Section>
  );
}
